/**
 * @mui/x-telemetry v8.5.3
 *
 * @license MUI X Commercial
 * This source code is licensed under the commercial license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "muiXTelemetryEvents", {
  enumerable: true,
  get: function () {
    return _events.default;
  }
});
exports.sendMuiXTelemetryEvent = exports.muiXTelemetrySettings = void 0;
var _events = _interopRequireDefault(require("./runtime/events"));
var _sender = _interopRequireDefault(require("./runtime/sender"));
var _settings = _interopRequireDefault(require("./runtime/settings"));
const noop = () => {};

// To cut unused imports in production as early as possible
const sendMuiXTelemetryEvent = exports.sendMuiXTelemetryEvent = process.env.NODE_ENV === 'production' ? noop : _sender.default;

// To cut unused imports in production as early as possible
const muiXTelemetrySettings = exports.muiXTelemetrySettings = process.env.NODE_ENV === 'production' ? {
  enableDebug: noop,
  enableTelemetry: noop,
  disableTelemetry: noop
} : _settings.default;